import { parseUrl } from 'query-string';

import { IAppState } from '@mobx';

export const fetchData = (actions: Function[]) => {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	return (target: any) => {
		const componentDidMount = target.prototype.componentDidMount;

		target.fetchData = async (state: IAppState, params: {}, query: {}) => await Promise.all(actions.map((action) => action(state, params, query)));

		target.prototype.componentDidMount = async function() {
			await target.fetchData(
				this.props,
				this.props.match?.params || {},
				parseUrl(window.location.search).query || {},
			);

			if (typeof componentDidMount === 'function') {
				componentDidMount.call(this);
			}
		};

		return target;
	};
};
